<template>
  <v-main>
    <index-navigator></index-navigator>
    <v-main style="min-height:650px; " class=" grey lighten-3">
      <!-- 页面均不需要缓存 -->
      <router-view />
    </v-main>
    <index-footer></index-footer>

    <!-- 在线客服 -->
    <div v-if="onlineServiceShow" style="position: fixed;bottom:90px;right:16px;">
      <v-icon color="grey" small style="position:absolute;top:-10px;right:-5px;" @click="onCloseOnlineService">mdi-close</v-icon>
      <v-img style="cursor: pointer;" @click="onOnlineService" :src="`${Utility.RES_SERVER}/static/img/online-service.png`" width="64" contain></v-img>
    </div>

    <!-- 回到顶部 -->
    <v-btn v-show="backTopShow" @click="backTop" fab dark color="primary" bottom right fixed large style="opacity:0.85;">
      <v-icon>mdi-arrow-collapse-up</v-icon>
    </v-btn>
  </v-main>
</template>
<script>
export default {
  data () {
    return {
      backTopShow: false,
      // 对接在线客服
      onlineServiceShow: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    onCloseOnlineService () {
      this.onlineServiceShow = false;
    },
    onOnlineService () {
      // TODO 对接在线客服
    },
    backTop () {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 20;
          document.documentElement.scrollTop -= 20;
        } else {
          clearInterval(back);
        }
      });
    },
    handleScroll () {
      if (document.documentElement.scrollTop + document.body.scrollTop > 200) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    }
  },
  components: {
    IndexNavigator: () => import('./IndexNavigator.vue'),
    IndexFooter: () => import('./IndexFooter.vue'),
  }
}
</script>